export { default, getModalConfig } from './Modal';
export { default as shouldOpenModal } from './shouldOpenModal';
